import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const BrandContext = createContext({ mode: "main", brand: null, loading: true });

export function BrandProvider({ children }) {
  const [state, setState] = useState({ mode: "main", brand: null, loading: true });

  useEffect(() => {
    const fetchCtx = async () => {
      try {
        const params = new URLSearchParams(window.location.search);
        const brand = params.get("brand");
        const url = brand ? `/context?brand=${encodeURIComponent(brand)}` : `/context`;
        const { data } = await api.get(url);
        setState({ mode: data.mode, brand: data.brand, loading: false });
        applyBrandTheme(data.brand);
      } catch (e) {
        setState({ mode: "main", brand: null, loading: false });
      }
    };
    fetchCtx();
  }, []);

  return <BrandContext.Provider value={state}>{children}</BrandContext.Provider>;
}

// Relative luminance per WCAG 2.0 — used to pick black/white text against any bg.
function luminance(hex) {
  const h = hex.replace("#", "");
  const v = h.length === 3 ? h.split("").map((c) => c + c).join("") : h;
  if (v.length !== 6) return 0;
  const r = parseInt(v.slice(0, 2), 16) / 255;
  const g = parseInt(v.slice(2, 4), 16) / 255;
  const b = parseInt(v.slice(4, 6), 16) / 255;
  const f = (c) => (c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4));
  return 0.2126 * f(r) + 0.7152 * f(g) + 0.0722 * f(b);
}

function contrastForeground(hex) {
  return luminance(hex) > 0.55 ? "#0A0A0A" : "#FFFFFF";
}

function applyBrandTheme(brand) {
  const root = document.documentElement;
  const primary = brand?.primary_color || "#E11D48";
  const secondary = brand?.secondary_color || "#FAFAFA";
  root.style.setProperty("--brand-primary", primary);
  root.style.setProperty("--brand-secondary", secondary);
  root.style.setProperty("--brand-primary-foreground", contrastForeground(primary));
}

export const useBrand = () => useContext(BrandContext);
